/* eslint-disable no-unused-vars */
export enum Elevations {
  FULL = 'full-elevation',
  NO_ELEVATION = 'no-elevation',
}
